"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleBlock = void 0;
const is_block_active_1 = require("./is-block-active");
const slate_1 = require("slate");
const LIST_TYPES = ['numbered-list', 'bulleted-list'];
exports.toggleBlock = (editor, format) => {
    const isActive = is_block_active_1.isBlockActive(editor, format);
    const isList = LIST_TYPES.includes(format);
    slate_1.Transforms.unwrapNodes(editor, {
        match: (n) => LIST_TYPES.includes((!slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type) || ''),
        split: true,
    });
    const newProperties = {
        type: isActive ? 'paragraph' : isList ? 'list-item' : format,
    };
    slate_1.Transforms.setNodes(editor, newProperties);
    if (!isActive && isList) {
        const block = { type: format, children: [] };
        slate_1.Transforms.wrapNodes(editor, block);
    }
};
//# sourceMappingURL=toggle-block.js.map